<template>
    <div>
        <div  class="w-full">
            <div class="row">
                <div class="col-md-7 col-12 d-flex mb-2">
                    <div class="text-2xl text-grey-darkest mr-2">Automation Logs</div>
                </div>
                <div class="col-md-5 col-12 d-flex mb-2">
                    <div class="flex pull-right">
                        <v-date-picker v-model="selectedDateRange" is-range :masks="rangeMask" @input="setFixedDateRange({id:0})" :popover="{ visibility: 'click' }">
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="flex w-full">
                                    <div class="flex-column mr-2">
                                        <label class="text-sm text-grey-darkest">Start Date</label>
                                        <input
                                            :value="inputValue.start"
                                            v-on="inputEvents.start"
                                            class=" mr-1 cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l rounded-r text-grey-darkest text-sm w-full"
                                        />
                                    </div>
                                    <div class="flex-column">
                                        <label class="text-sm text-grey-darkest">End Date</label>
                                        <input
                                            :value="inputValue.end"
                                            v-on="inputEvents.end"
                                            class="cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l text-grey-darkest text-sm w-full"
                                        />
                                    </div>
                                </div>
                            </template>
                        </v-date-picker>
                        <div class="flex-column">
                            <label class="text-sm text-grey-darkest"></label>
                            <div
                                class="-ml-0 border-b-1 border-grey border-r-1 border-t-1 cursor-pointer flex hover:bg-grey hover:text-white text-grey-darkest items-center px-2 rounded-r cross-btn"
                                @click.stop="clearDates">
                                <i class="material-icons text-sm">clear</i>
                            </div>
                        </div>
                        <div class="flex-column">
                            <button
                                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded-full text-followup-nav"
                                @click="applySearchFilter" style="margin-top: 32px;margin-left: 10px;" type="button">
                                Apply
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="zero_search_results || this.automationLogs.length > 0">

            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider creating a new automation.</div>
            </div>
            <div v-if="this.automationLogs.length > 0" class="bg-white shadow-md rounded mb-6 mt-4">

                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Name</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Type</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Action</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Object</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Project</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Company</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Contact</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">User</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Sequence</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Old Value</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Action Field</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">New Value</th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Date Time</th>
                        <th class="bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="automationLog in automationLogs" :key="automationLog.id" class="hover:bg-grey-lighter cursor-pointer border-b-1">
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.name ? automationLog.name : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.type ? automationLog.type : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.action ? automationLog.action : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.object ? automationLog.object : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.project ? automationLog.project : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.company ? automationLog.company : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.company_contact ? automationLog.company_contact : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.email_users_value ? automationLog.email_users_value : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.sequence_name ? automationLog.sequence_name : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ ((automationLog.sales_behavior_id || automationLog.contact_sales_behavior_id) ? formatDateValue(automationLog.old_value, automationLog, 'old') : (automationLog.old_value ? automationLog.old_value : '--')) }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.field ? ((automationLog.field === 'empty' || automationLog.field === 'Empty') ? '--' : automationLog.field) : '--' }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ ((automationLog.sales_behavior_id || automationLog.contact_sales_behavior_id) ? formatDateValue(automationLog.new_value, automationLog, 'new') : (automationLog.new_value && automationLog.action !== 'email' ? automationLog.new_value : '--')) }}</td>
                            <td class="pl-2 border-b border-grey-light text-xs md:table-cell">{{ automationLog.created_at ? createdAtFormat(automationLog.created_at) : '--' }}</td>
                            <td class="text-right">
                                <i v-if="(automationLog.is_undo === 0) && (automationLog.action !== 'Email')" class="fa fa-undo mr-2" @click="undoAutomationLog(automationLog.id)"></i>
                                <i class="fa fa-trash mr-2" @click="deleteAutomationLog(automationLog.id)"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider creating a new automation.</div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';
import draggable from 'vuedraggable';
import moment from "moment";

export default {
    name: "automation-logs",
    components:{Multiselect, Datepicker},
    props: ['dateRange', 'fixedDateRangeIdentifier', 'masks'],
    data() {
        return {
            automationLogs: [],
            dateRanges: [],
            rangeMask: {
                input: this.masks.moment_mask,
            },
            selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
            selectedDateRange: this.dateRange ? {
                start: moment(this.dateRange.start).startOf('year').format('MM/DD/YYYY'),
                end: moment(this.dateRange.end).endOf('year').format('MM/DD/YYYY')
            } : null,
            filter: '',
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            data_loading: false,
            zero_search_results: false,
        }
    },
    created() {
        this.fetchAutomationLogs();
    },

    methods: {
        fetchAutomationLogs(page = 1) {
            this.data_loading = true;
            let self = this;
            let startDate = this.selectedDateRange ? this.selectedDateRange.start : null;
            let endDate = this.selectedDateRange ? this.selectedDateRange.end : null;
            axios.get(route('automation.get-automation-logs', {page: page, start_date: startDate, end_date: endDate})).then(({data}) => {
                self.automationLogs = data.data;
                self.pagination = data;
                this.data_loading = false;
            });
        },
        deleteAutomationLog(id) {
            this.confirmAction('Yes, delete it!')
                .then((result) => {
                    if(result.value) {
                        axios.post(route('automation.delete-automation-log', {automationLogId: id })).then((response) => {
                            if (response.status) {
                                this.getToast().fire({
                                    type: 'success',
                                    title: response.data.message
                                });
                                this.fetchAutomationLogs();
                            } else {
                                this.getToast().fire({
                                    type: 'error',
                                    title: response.data.message
                                });
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        undoAutomationLog(id) {
            this.confirmAction('Yes, undo it!')
            .then((result) => {
                if(result.value) {
                    axios.post(route('automation.undo-automation-log', {automationLogId: id })).then((response) => {
                        if (response.status) {
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.fetchAutomationLogs();
                        } else {
                            this.getToast().fire({
                                type: 'error',
                                title: response.data.message
                            });
                        }
                    });
                }
            })
                .catch((error) => {
                console.log(error);
            });
        },
        createdAtFormat(date){
            return moment(date).format('YYYY-MM-DD hh:mm a')
        },
        applySearchFilter() {
            this.fetchAutomationLogs();
        },
        setFixedDateRange(dateRange) {
            if (!dateRange) return;

            this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];

            if(dateRange.id > 0)
                this.selectedDateRange = {
                    start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                    end: moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
                };
        },
        clearDates() {
            this.selectedDateRange = null;
        },
        goToPage(page) {
            this.fetchAutomationLogs(page);
        },
        confirmAction(confirmButtonText){
            return new Promise((resolve, reject) => {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: confirmButtonText
                }).then((result) => {
                    resolve(result);
                }).catch((error) => {
                    reject();
                });
            });
        },
        formatDateValue(date, automationLog, type) {
            if(date) {
                let dateFormat = 'YYYY-MM-DD';
                if(type === 'new') {
                    dateFormat = automationLog.sales_behavior_time ? 'YYYY-MM-DD hh:mm A' : 'YYYY-MM-DD';
                    date = date.split('T')[0];
                    date = automationLog.sales_behavior_time ? date + ' ' + automationLog.sales_behavior_time : date;
                }
                else {
                    const dateTime = date.split(' ');
                    dateFormat = typeof dateTime[1] === 'undefined' ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm A';
                }

                return moment(date).isValid() === true ? moment.utc(date).local().format(dateFormat) : '--'
            }
            else {
                return '--';
            }
        }
    }
}
</script>

<style scoped>
    .date-picker-input {
     padding: .61rem .5rem !important;
    }
    .cross-btn {
        height: 38px;
        margin-top: 7px;
    }
</style>
